module.exports = __webpack_public_path__ + "static/media/ios_plus_home.baa96daf.png";